/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext, useState, useCallback } from "react";
import { Toast } from "@/components/Toast";
/** @type {{showToast: (message: import('react').ReactNode, type?: string, duration?: number) => void, showError: (message: import('react').ReactNode, duration?: number) => void, showSuccess: (message: import('react').ReactNode, duration?: number) => void, showInfo: (message: import('react').ReactNode, duration?: number) => void, showWarning: (message: import('react').ReactNode, duration?: number) => void}} */
const defaultToastContext = {
    showToast: () => {},
    showError: () => {},
    showSuccess: () => {},
    showInfo: () => {},
    showWarning: () => {},
};

const ToastContext = createContext(defaultToastContext);

export const ToastProvider = ({ children }) => {
    const [toasts, setToasts] = useState([]);

    const showToast = useCallback(
        (message, type = "error", duration = 4000) => {
            const id = Date.now() + Math.random().toString();
            setToasts((prev) => [...prev, { id, message, type, duration }]);
        },
        []
    );

    const removeToast = useCallback((id) => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
    }, []);

    const showError = useCallback(
        (message, duration) => showToast(message, "error", duration),
        [showToast]
    );
    const showSuccess = useCallback(
        (message, duration) => showToast(message, "success", duration),
        [showToast]
    );
    const showInfo = useCallback(
        (message, duration) => showToast(message, "info", duration),
        [showToast]
    );
    const showWarning = useCallback(
        (message, duration) => showToast(message, "warning", duration),
        [showToast]
    );

    return (
        <ToastContext.Provider
            value={{ showToast, showError, showSuccess, showInfo, showWarning }}
        >
            {children}

            {/* Centered Top Toast Container (Curtain Drop) */}
            <div
                data-live-region
                className="fixed top-2 sm:top-5 left-1/2 -translate-x-1/2 z-[9999999] flex flex-col items-center space-y-2 max-w-3xl w-[92vw] sm:w-auto pointer-events-none"
            >
                {toasts.map((t) => (
                    <Toast
                        key={t.id}
                        id={t.id}
                        message={t.message}
                        type={t.type}
                        duration={t.duration}
                        onClose={() => removeToast(t.id)}
                    />
                ))}
            </div>
        </ToastContext.Provider>
    );
};

export const useToast = () => {
    const context = useContext(ToastContext);
    if (!context) {
        return defaultToastContext;
    }
    return context;
};

export default ToastProvider;
